const Skeleton = ({ className }: { className: string }) => (
  <div className={`animate-pulse bg-gray-200 rounded ${className}`} />
);

const LowStockProductsSkeleton: React.FC = () => {
  return (
    <div className="rounded-xl bg-white/80 border p-4 shadow-sm overflow-x-auto">
      {/* Header */}
      <div className="flex justify-between items-center mb-3">
        <div className="flex items-center gap-2">
          <Skeleton className="h-5 w-40" />
          <Skeleton className="h-5 w-16 rounded-full" />
        </div>
        <Skeleton className="h-4 w-32" />
      </div>

      {/* Table */}
      <table className="w-full text-sm min-w-[600px]">
        <thead className="border-b">
          <tr>
            {Array.from({ length: 6 }).map((_, i) => (
              <th key={i} className="py-2">
                <Skeleton className="h-4 w-20" />
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {Array.from({ length: 5 }).map((_, i) => (
            <tr key={i} className="border-b last:border-none">
              {Array.from({ length: 6 }).map((__, j) => (
                <td key={j} className="py-2">
                  <Skeleton className="h-4 w-full max-w-[100px]" />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default LowStockProductsSkeleton;
